export default "__VITE_ASSET__CvToA7HI__"